import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58f3ee0b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=58f3ee0b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3ee0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f3ee0b')) {
      api.createRecord('58f3ee0b', component.options)
    } else {
      api.reload('58f3ee0b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58f3ee0b&scoped=true", function () {
      api.rerender('58f3ee0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/fortune/ai-prompt/index.vue"
export default component.exports